const benefits = [
  {
    icon: "✓",
    title: "Passend begleiten",
    text: "Übungen gezielt auswählen und Lernwege übersichtlich im Blick behalten.",
  },
  {
    icon: "→",
    title: "Selbstständig üben",
    text: "Klare Aufgaben und verständliche Rückmeldungen geben Orientierung.",
  },
  {
    icon: "★",
    title: "Fortschritte würdigen",
    text: "Entwicklung sichtbar machen und den nächsten Schritt gemeinsam planen.",
  },
];

export function PublicHome() {
  return (
    <main className="public-home">
      <header className="public-header">
        <a className="public-brand" href="/" aria-label="Calepia Startseite">
          <img src="/brand/calepia_logo_schrift.webp" alt="Calepia – die lerntherapeutische Übungsplattform" />
        </a>
        <a className="public-login-link" href="/login">Anmelden <span aria-hidden="true">→</span></a>
      </header>

      <section className="public-hero" aria-labelledby="public-hero-title">
        <div className="public-hero-copy">
          <p className="public-kicker">Lerntherapeutisch begleitet üben</p>
          <h1 id="public-hero-title">Schritt für Schritt<br />zum Lernerfolg.</h1>
          <p className="public-hero-lead">
            Calepia verbindet passende Übungen mit einem klaren Blick auf den Lernweg –
            für eine motivierende Begleitung zwischen und während der Lerntherapie.
          </p>
          <div className="public-hero-actions">
            <a className="public-primary-action" href="/login">Zur Anmeldung <span aria-hidden="true">→</span></a>
            <a className="public-secondary-action" href="#was-calepia-kann">Mehr erfahren</a>
          </div>
          <p className="public-access-note"><span aria-hidden="true">✓</span> Der persönliche Lernbereich ist geschützt und nur nach Anmeldung zugänglich.</p>
        </div>
        <div className="public-hero-visual" aria-hidden="true">
          <span className="public-sun-dot" />
          <span className="public-sky-dot" />
          <img src="/brand/lepi-winkend.webp" alt="" />
        </div>
      </section>

      <section className="public-benefits" id="was-calepia-kann" aria-labelledby="benefits-title">
        <div className="public-section-heading">
          <p className="public-kicker">Was Calepia unterstützt</p>
          <h2 id="benefits-title">Gemeinsam lernen. Klar begleitet.</h2>
          <p>Die Plattform bringt Üben, Beobachten und Weiterentwickeln an einem Ort zusammen.</p>
        </div>
        <div className="public-benefit-grid">
          {benefits.map((benefit) => (
            <article className="public-benefit-card" key={benefit.title}>
              <span aria-hidden="true">{benefit.icon}</span>
              <h3>{benefit.title}</h3>
              <p>{benefit.text}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="public-audiences" aria-label="Calepia für Lerntherapeutinnen, Lerntherapeuten und Lernende">
        <article className="public-audience-card public-audience-professionals">
          <div>
            <p className="public-kicker">Für Lerntherapeut:innen</p>
            <h2>Gezielt fördern und Entwicklungen einordnen.</h2>
            <p>
              Lerninhalte strukturiert bereitstellen, Übungsphasen begleiten und Ergebnisse als Grundlage
              für die weitere Förderung nutzen.
            </p>
          </div>
          <img src="/brand/lepi-erklaerend.webp" alt="" />
        </article>
        <article className="public-audience-card public-audience-learners">
          <div>
            <p className="public-kicker">Für Lernende</p>
            <h2>In Ruhe üben und Erfolge erleben.</h2>
            <p>
              Verständliche Aufgaben, freundliche Rückmeldungen und kleine Schritte schaffen Orientierung –
              ohne unnötigen Druck.
            </p>
          </div>
          <img src="/brand/lepi-daumen-hoch.webp" alt="" />
        </article>
      </section>

      <section className="public-closing" aria-labelledby="public-closing-title">
        <img src="/brand/calepia_logo_mit_raupe.webp" alt="" />
        <div>
          <p className="public-kicker">Bereit für den nächsten Schritt?</p>
          <h2 id="public-closing-title">Willkommen bei Calepia.</h2>
          <p>Mit deinen Zugangsdaten gelangst du direkt in deinen persönlichen Bereich.</p>
        </div>
        <a className="public-primary-action" href="/login">Jetzt anmelden <span aria-hidden="true">→</span></a>
      </section>

      <footer className="public-footer">
        <span>Calepia – die lerntherapeutische Übungsplattform</span>
        <nav aria-label="Rechtliches">
          <a href="#/legal/impressum">Impressum</a>
          <a href="#/legal/datenschutz">Datenschutz</a>
          <a href="/THIRD-PARTY-NOTICES.txt">Lizenzen</a>
        </nav>
      </footer>
    </main>
  );
}
